import jsPDF from 'jspdf';

// Helper function to remove diacritics if needed
const removeDiacritics = (str) => {
  return str
    .replace(/ă/g, 'a')
    .replace(/â/g, 'a')
    .replace(/î/g, 'i')
    .replace(/ș/g, 's')
    .replace(/ț/g, 't')
    .replace(/Ă/g, 'A')
    .replace(/Â/g, 'A')
    .replace(/Î/g, 'I')
    .replace(/Ș/g, 'S')
    .replace(/Ț/g, 'T');
};

export const generateDevizPDF = (quoteData, clientInfo = {}) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  
  // Client info with defaults
  const clientName = clientInfo.clientName || 'Client IzoMAG';
  const clientPhone = clientInfo.clientPhone || '';
  const projectName = clientInfo.projectName || '';
  const devizNumber = clientInfo.devizNumber || '';
  
  // Calculate totals
  let totalManopera = 0;
  let totalMaterial = 0;
  
  quoteData.items.forEach(item => {
    totalManopera += item.unitLabor * item.quantity;
    totalMaterial += item.unitPrice * item.quantity;
  });
  
  const totalCheltuieliDirecte = totalManopera + totalMaterial;
  const tva = totalCheltuieliDirecte * 0.21;
  const totalCuTVA = totalCheltuieliDirecte + tva;
  
  // BACKGROUND WATERMARK - Text IzoMAG
  const drawBackgroundWatermark = () => {
    doc.saveGraphicsState();
    doc.setGState(new doc.GState({ opacity: 0.08 }));
    doc.setTextColor(8, 145, 178);
    doc.setFontSize(80);
    doc.setFont(undefined, 'bold');
    
    const watermarkText = 'IzoMAG';
    const textWidth = doc.getTextWidth(watermarkText);
    
    doc.text(watermarkText, (pageWidth - textWidth) / 2, pageHeight / 2, {
      angle: 45
    });
    
    doc.restoreGraphicsState();
  };
  
  // Draw background on first page
  drawBackgroundWatermark();
  
  // HEADER with colored background
  const today = new Date();
  const dateStr = `${today.getDate().toString().padStart(2, '0')}.${(today.getMonth() + 1).toString().padStart(2, '0')}.${today.getFullYear()}`;
  
  let yPos = 20;
  
  // Header background - Darker turquoise gradient
  doc.setFillColor(8, 145, 178);
  doc.rect(0, 0, pageWidth, 40, 'F');
  
  doc.setFillColor(20, 184, 166);
  doc.rect(0, 0, pageWidth, 35, 'F');
  
  // Header text in white
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.setFont(undefined, 'bold');
  doc.text('IzoMAG', 15, 12);
  
  doc.setFontSize(8);
  doc.setFont(undefined, 'normal');
  doc.text('La noi gasesti solutia corecta la pretul corect', 15, 17);
  
  // Deviz number and date on the right
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  if (devizNumber) {
    doc.text(devizNumber, pageWidth - 15, 12, { align: 'right' });
  }
  doc.setFontSize(9);
  doc.setFont(undefined, 'normal');
  doc.text(`Data: ${dateStr}`, pageWidth - 15, 18, { align: 'right' });
  
  // Project info line
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  let headerText = removeDiacritics(`${quoteData.roofTypeName} - ${quoteData.subType}`);
  if (projectName) {
    headerText = removeDiacritics(`Proiect: ${projectName}`);
  }
  doc.text(headerText, 15, 26);
  
  // Client info line
  doc.setFontSize(9);
  doc.setFont(undefined, 'normal');
  let clientText = removeDiacritics(`Client: ${clientName}`);
  if (clientPhone) {
    clientText += ` | Tel: ${clientPhone}`;
  }
  doc.text(clientText, 15, 32);
  
  // Reset text color for body
  doc.setTextColor(0, 0, 0);
  
  // TABLE HEADER
  yPos = 50;
  
  const colWidths = [55, 12, 18, 25, 25, 25];
  const colPositions = [10];
  for (let i = 1; i < colWidths.length; i++) {
    colPositions.push(colPositions[i - 1] + colWidths[i - 1]);
  }
  
  // Draw header background
  doc.setFillColor(8, 145, 178);
  doc.rect(10, yPos, pageWidth - 20, 10, 'F');
  
  // Header texts in white
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(8);
  doc.setFont(undefined, 'bold');
  doc.text('Denumire operatiune', colPositions[0] + 2, yPos + 7);
  doc.text('UM', colPositions[1] + 2, yPos + 7);
  doc.text('Cantitate', colPositions[2] + 2, yPos + 7);
  doc.text('Pret/UM', colPositions[3] + 2, yPos + 4);
  doc.text('Manopera', colPositions[3] + 2, yPos + 8);
  doc.text('Pret/UM', colPositions[4] + 2, yPos + 4);
  doc.text('Material', colPositions[4] + 2, yPos + 8);
  doc.text('Total RON', colPositions[5] + 2, yPos + 7);
  
  // Draw header borders
  doc.setDrawColor(8, 145, 178);
  doc.setLineWidth(0.5);
  for (let i = 0; i < colPositions.length; i++) {
    doc.line(colPositions[i], yPos, colPositions[i], yPos + 10);
  }
  doc.line(pageWidth - 10, yPos, pageWidth - 10, yPos + 10);
  doc.line(10, yPos, pageWidth - 10, yPos);
  doc.line(10, yPos + 10, pageWidth - 10, yPos + 10);
  
  yPos += 10;
  
  // Reset text color for table content
  doc.setTextColor(30, 41, 59);
  
  // TABLE CONTENT with alternating row colors
  doc.setFont(undefined, 'normal');
  doc.setFontSize(8);
  
  quoteData.items.forEach((item, idx) => {
    // Check if we need new page
    if (yPos > pageHeight - 40) {
      doc.addPage();
      drawBackgroundWatermark();
      yPos = 20;
    }
    
    const rowHeight = 8;
    
    // Alternating row background
    if (idx % 2 === 0) {
      doc.setFillColor(240, 249, 255);
      doc.rect(10, yPos, pageWidth - 20, rowHeight, 'F');
    }
    
    // Operation name
    const operationName = removeDiacritics(`${item.phaseName} - ${item.materialName}`);
    const lines = doc.splitTextToSize(operationName, colWidths[0] - 4);
    doc.text(lines, colPositions[0] + 2, yPos + 5);
    
    const textHeight = lines.length * 4;
    const actualRowHeight = Math.max(rowHeight, textHeight + 2);
    
    // UM
    doc.text(item.unit, colPositions[1] + 2, yPos + 5);
    
    // Cantitate
    doc.text(item.quantity.toFixed(2), colPositions[2] + colWidths[2] - 2, yPos + 5, { align: 'right' });
    
    // Pret/UM Manopera
    doc.text(item.unitLabor.toFixed(2), colPositions[3] + colWidths[3] - 2, yPos + 5, { align: 'right' });
    
    // Pret/UM Material
    doc.text(item.unitPrice.toFixed(2), colPositions[4] + colWidths[4] - 2, yPos + 5, { align: 'right' });
    
    // Total RON
    const totalRON = item.total.toFixed(2);
    doc.setFont(undefined, 'bold');
    doc.text(totalRON, colPositions[5] + colWidths[5] - 2, yPos + 5, { align: 'right' });
    doc.setFont(undefined, 'normal');
    
    yPos += actualRowHeight;
    
    // Draw row border
    doc.setDrawColor(165, 243, 252);
    doc.setLineWidth(0.2);
    doc.line(10, yPos, pageWidth - 10, yPos);
    
    // Vertical borders
    doc.setDrawColor(207, 250, 254);
    for (let i = 0; i < colPositions.length; i++) {
      doc.line(colPositions[i], yPos - actualRowHeight, colPositions[i], yPos);
    }
    doc.line(pageWidth - 10, yPos - actualRowHeight, pageWidth - 10, yPos);
  });
  
  // TOTALS SECTION
  yPos += 8;
  
  if (yPos > pageHeight - 70) {
    doc.addPage();
    drawBackgroundWatermark();
    yPos = 20;
  }
  
  // Total background
  doc.setFillColor(224, 247, 250);
  doc.rect(10, yPos, pageWidth - 20, 8, 'F');
  
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.setTextColor(8, 145, 178);
  doc.text('TOTAL Cheltuieli directe:', 15, yPos + 5);
  doc.text(totalCheltuieliDirecte.toFixed(2), pageWidth - 15, yPos + 5, { align: 'right' });
  
  yPos += 10;
  doc.setTextColor(30, 41, 59);
  doc.setFont(undefined, 'normal');
  doc.setFontSize(8);
  
  const summaryData = [
    ['MANOPERA:', totalManopera],
    ['MATERIALE:', totalMaterial]
  ];
  
  summaryData.forEach(([label, value]) => {
    doc.text(label, 20, yPos);
    doc.text(value.toFixed(2), pageWidth - 15, yPos, { align: 'right' });
    yPos += 5;
  });
  
  // TVA and Total with colored backgrounds
  yPos += 5;
  
  // TVA background
  doc.setFillColor(254, 249, 195);
  doc.rect(10, yPos - 2, pageWidth - 20, 7, 'F');
  
  doc.setFont(undefined, 'bold');
  doc.setTextColor(133, 77, 14);
  doc.text('TVA (21%):', 20, yPos);
  doc.text(tva.toFixed(2), pageWidth - 15, yPos, { align: 'right' });
  
  yPos += 10;
  
  // Final total background
  doc.setFillColor(8, 145, 178);
  doc.rect(10, yPos - 3, pageWidth - 20, 10, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(12);
  doc.text('TOTAL CU TVA:', 20, yPos);
  doc.text(totalCuTVA.toFixed(2) + ' RON', pageWidth - 15, yPos, { align: 'right' });
  
  // FOOTER
  const footerY = pageHeight - 25;
  
  // Footer background
  doc.setFillColor(241, 245, 249);
  doc.rect(0, footerY - 5, pageWidth, 30, 'F');
  
  doc.setTextColor(71, 85, 105);
  doc.setFontSize(8);
  doc.setFont(undefined, 'normal');
  
  doc.text('Contractor:', 15, footerY);
  doc.setFont(undefined, 'bold');
  doc.setTextColor(8, 145, 178);
  doc.text('S.C LESPEZIART CON S.R.L', 40, footerY);
  
  doc.setFont(undefined, 'normal');
  doc.setTextColor(71, 85, 105);
  doc.text('Beneficiar:', 120, footerY);
  doc.setFont(undefined, 'bold');
  doc.setTextColor(8, 145, 178);
  doc.text(removeDiacritics(clientName), 145, footerY);
  
  doc.setFontSize(7);
  doc.setFont(undefined, 'normal');
  doc.setTextColor(100, 116, 139);
  doc.text('Intocmit: Ing. Lespezeanu Tudor | Tel: 0755 898 253', pageWidth / 2, footerY + 5, { align: 'center' });
  
  return doc;
};

// Generate Order PDF for admin
export const generateOrderPDF = (order) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  
  const STATUS_LABELS = {
    new: 'Noua',
    confirmed: 'Confirmata',
    processing: 'In procesare',
    shipped: 'Expediata',
    delivered: 'Livrata',
    cancelled: 'Anulata'
  };

  const PAYMENT_LABELS = {
    card: 'Card Bancar',
    transfer: 'Transfer Bancar',
    cash: 'Ramburs la Livrare'
  };

  // Format date
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleDateString('ro-RO', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // HEADER
  doc.setFillColor(8, 145, 178);
  doc.rect(0, 0, pageWidth, 35, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(24);
  doc.setFont(undefined, 'bold');
  doc.text('IzoMAG', 15, 18);
  
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  doc.text('Comanda de Materiale', 15, 27);
  
  // Order number box
  doc.setFillColor(249, 115, 22);
  doc.roundedRect(pageWidth - 55, 8, 45, 20, 3, 3, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(12);
  doc.setFont(undefined, 'bold');
  doc.text(removeDiacritics(order.order_number || 'CMD0000'), pageWidth - 32.5, 20, { align: 'center' });
  
  let y = 45;
  
  // STATUS & DATE
  doc.setTextColor(100, 116, 139);
  doc.setFontSize(9);
  doc.setFont(undefined, 'normal');
  doc.text(`Data: ${formatDate(order.created_at)}`, 15, y);
  doc.text(`Status: ${removeDiacritics(STATUS_LABELS[order.status] || order.status)}`, pageWidth - 15, y, { align: 'right' });
  
  y += 10;
  
  // CUSTOMER INFO BOX
  doc.setFillColor(240, 253, 250);
  doc.roundedRect(15, y, pageWidth - 30, 35, 3, 3, 'F');
  doc.setDrawColor(6, 182, 212);
  doc.setLineWidth(0.5);
  doc.roundedRect(15, y, pageWidth - 30, 35, 3, 3, 'S');
  
  doc.setTextColor(8, 145, 178);
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.text('Informatii Client', 20, y + 8);
  
  doc.setTextColor(15, 23, 42);
  doc.setFontSize(9);
  doc.setFont(undefined, 'normal');
  
  const col1X = 20;
  const col2X = pageWidth / 2 + 5;
  
  doc.text(`Nume: ${removeDiacritics(order.customer_name || '-')}`, col1X, y + 16);
  doc.text(`Telefon: ${order.customer_phone || '-'}`, col1X, y + 23);
  doc.text(`Email: ${order.customer_email || '-'}`, col1X, y + 30);
  
  doc.text(`Adresa: ${removeDiacritics(order.shipping_address || '-')}`, col2X, y + 16);
  doc.text(`Oras: ${removeDiacritics(order.shipping_city || '-')}${order.shipping_county ? ', ' + removeDiacritics(order.shipping_county) : ''}`, col2X, y + 23);
  doc.text(`Plata: ${removeDiacritics(PAYMENT_LABELS[order.payment_method] || order.payment_method)}`, col2X, y + 30);
  
  y += 45;
  
  // PRODUCTS TABLE HEADER
  doc.setFillColor(8, 145, 178);
  doc.rect(15, y, pageWidth - 30, 10, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(9);
  doc.setFont(undefined, 'bold');
  doc.text('Nr.', 18, y + 7);
  doc.text('Produs', 30, y + 7);
  doc.text('Cant.', 120, y + 7);
  doc.text('Pret/buc', 140, y + 7);
  doc.text('Total', pageWidth - 20, y + 7, { align: 'right' });
  
  y += 12;
  
  // PRODUCTS ROWS
  doc.setTextColor(15, 23, 42);
  doc.setFont(undefined, 'normal');
  doc.setFontSize(8);
  
  const items = order.items || [];
  items.forEach((item, index) => {
    // Alternate row background
    if (index % 2 === 0) {
      doc.setFillColor(248, 250, 252);
      doc.rect(15, y - 3, pageWidth - 30, 8, 'F');
    }
    
    doc.setTextColor(100, 116, 139);
    doc.text(`${index + 1}`, 18, y + 2);
    
    doc.setTextColor(15, 23, 42);
    // Truncate long product names
    const productName = removeDiacritics(item.product_name || 'Produs');
    const truncatedName = productName.length > 45 ? productName.substring(0, 42) + '...' : productName;
    doc.text(truncatedName, 30, y + 2);
    
    doc.text(`${item.quantity || 0}`, 120, y + 2);
    doc.text(`${(item.unit_price || 0).toFixed(2)}`, 140, y + 2);
    
    doc.setFont(undefined, 'bold');
    doc.text(`${(item.total_price || 0).toFixed(2)} LEI`, pageWidth - 20, y + 2, { align: 'right' });
    doc.setFont(undefined, 'normal');
    
    y += 8;
    
    // Check for page break
    if (y > 250) {
      doc.addPage();
      y = 20;
    }
  });
  
  // TOTALS SECTION
  y += 5;
  doc.setDrawColor(226, 232, 240);
  doc.setLineWidth(0.3);
  doc.line(pageWidth - 80, y, pageWidth - 15, y);
  
  y += 8;
  doc.setFontSize(9);
  doc.setTextColor(100, 116, 139);
  doc.text('Subtotal:', pageWidth - 80, y);
  doc.setTextColor(15, 23, 42);
  doc.text(`${(order.subtotal || 0).toFixed(2)} LEI`, pageWidth - 20, y, { align: 'right' });
  
  if (order.shipping_cost > 0) {
    y += 7;
    doc.setTextColor(100, 116, 139);
    doc.text('Transport:', pageWidth - 80, y);
    doc.setTextColor(15, 23, 42);
    doc.text(`${order.shipping_cost.toFixed(2)} LEI`, pageWidth - 20, y, { align: 'right' });
  }
  
  y += 10;
  doc.setFillColor(249, 115, 22);
  doc.roundedRect(pageWidth - 85, y - 5, 70, 12, 2, 2, 'F');
  
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(11);
  doc.setFont(undefined, 'bold');
  doc.text('TOTAL:', pageWidth - 80, y + 3);
  doc.text(`${(order.total || 0).toFixed(2)} LEI`, pageWidth - 20, y + 3, { align: 'right' });
  
  // NOTES
  if (order.notes) {
    y += 20;
    doc.setFillColor(254, 249, 195);
    doc.roundedRect(15, y, pageWidth - 30, 20, 2, 2, 'F');
    doc.setTextColor(161, 98, 7);
    doc.setFontSize(8);
    doc.setFont(undefined, 'bold');
    doc.text('Note:', 20, y + 6);
    doc.setFont(undefined, 'normal');
    doc.text(removeDiacritics(order.notes).substring(0, 100), 20, y + 13);
  }
  
  // FOOTER
  const footerY = 280;
  doc.setDrawColor(226, 232, 240);
  doc.setLineWidth(0.3);
  doc.line(15, footerY - 5, pageWidth - 15, footerY - 5);
  
  doc.setTextColor(100, 116, 139);
  doc.setFontSize(7);
  doc.text('IzoMAG - Solutia corecta la pretul corect | www.izomag.ro | Tel: 0755 898 253', pageWidth / 2, footerY, { align: 'center' });
  
  return doc;
};

// Generate Product Catalog PDF
export const generateCatalogPDF = (products) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 15;
  const contentWidth = pageWidth - margin * 2;

  const today = new Date();
  const dateStr = `${today.getDate().toString().padStart(2, '0')}.${(today.getMonth() + 1).toString().padStart(2, '0')}.${today.getFullYear()}`;

  // Group products by category
  const grouped = {};
  products.forEach(p => {
    const cat = p.category || 'Altele';
    if (!grouped[cat]) grouped[cat] = [];
    grouped[cat].push(p);
  });

  const drawHeader = () => {
    doc.setFillColor(8, 145, 178);
    doc.rect(0, 0, pageWidth, 32, 'F');

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(20);
    doc.setFont(undefined, 'bold');
    doc.text('IzoMAG', margin, 14);

    doc.setFontSize(8);
    doc.setFont(undefined, 'normal');
    doc.text('La noi gasesti solutia corecta la pretul corect', margin, 20);

    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('CATALOG PRODUSE', margin, 28);

    doc.setFontSize(9);
    doc.setFont(undefined, 'normal');
    doc.text(`Data: ${dateStr}`, pageWidth - margin, 14, { align: 'right' });
    doc.text(`${products.length} produse`, pageWidth - margin, 21, { align: 'right' });
  };

  const drawFooter = (pageNum) => {
    const footerY = pageHeight - 10;
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.line(margin, footerY - 5, pageWidth - margin, footerY - 5);
    doc.setTextColor(100, 116, 139);
    doc.setFontSize(7);
    doc.text('IzoMAG - www.izomag.ro | Tel: 0755 898 253 | Iasi, Romania', pageWidth / 2, footerY, { align: 'center' });
    doc.text(`Pagina ${pageNum}`, pageWidth - margin, footerY, { align: 'right' });
  };

  const checkNewPage = (yPos, needed, pageNum) => {
    if (yPos + needed > pageHeight - 20) {
      drawFooter(pageNum);
      doc.addPage();
      pageNum++;
      drawHeader();
      return { y: 40, page: pageNum };
    }
    return { y: yPos, page: pageNum };
  };

  // --- Page 1 ---
  let pageNum = 1;
  drawHeader();
  let y = 40;

  // Table column config
  const colNr = margin;
  const colName = margin + 10;
  const colBrand = margin + contentWidth * 0.55;
  const colPrice = margin + contentWidth * 0.75;
  const colUnit = margin + contentWidth * 0.92;

  const categoryNames = Object.keys(grouped).sort();

  categoryNames.forEach((catName) => {
    const catProducts = grouped[catName];

    const check = checkNewPage(y, 20, pageNum);
    y = check.y; pageNum = check.page;

    // Category header
    doc.setFillColor(240, 249, 255);
    doc.rect(margin, y, contentWidth, 9, 'F');
    doc.setDrawColor(8, 145, 178);
    doc.setLineWidth(0.5);
    doc.line(margin, y, margin, y + 9);

    doc.setTextColor(8, 145, 178);
    doc.setFontSize(10);
    doc.setFont(undefined, 'bold');
    doc.text(removeDiacritics(catName), margin + 4, y + 6);

    doc.setFontSize(8);
    doc.setFont(undefined, 'normal');
    doc.setTextColor(100, 116, 139);
    doc.text(`${catProducts.length} produse`, pageWidth - margin - 2, y + 6, { align: 'right' });
    y += 12;

    // Table header row
    const hdrCheck = checkNewPage(y, 10, pageNum);
    y = hdrCheck.y; pageNum = hdrCheck.page;

    doc.setFillColor(8, 145, 178);
    doc.rect(margin, y, contentWidth, 8, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(7);
    doc.setFont(undefined, 'bold');
    doc.text('Nr.', colNr + 2, y + 5.5);
    doc.text('Denumire produs', colName + 2, y + 5.5);
    doc.text('Brand', colBrand, y + 5.5);
    doc.text('Pret (LEI)', colPrice, y + 5.5);
    doc.text('UM', colUnit, y + 5.5);
    y += 8;

    catProducts.forEach((product, idx) => {
      const rowCheck = checkNewPage(y, 8, pageNum);
      y = rowCheck.y; pageNum = rowCheck.page;

      // Re-draw table header if landed on a fresh page
      if (rowCheck.y === 40) {
        doc.setFillColor(240, 249, 255);
        doc.rect(margin, y, contentWidth, 9, 'F');
        doc.setDrawColor(8, 145, 178);
        doc.setLineWidth(0.5);
        doc.line(margin, y, margin, y + 9);
        doc.setTextColor(8, 145, 178);
        doc.setFontSize(10);
        doc.setFont(undefined, 'bold');
        doc.text(removeDiacritics(catName) + ' (continuare)', margin + 4, y + 6);
        y += 12;

        doc.setFillColor(8, 145, 178);
        doc.rect(margin, y, contentWidth, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(7);
        doc.setFont(undefined, 'bold');
        doc.text('Nr.', colNr + 2, y + 5.5);
        doc.text('Denumire produs', colName + 2, y + 5.5);
        doc.text('Brand', colBrand, y + 5.5);
        doc.text('Pret (LEI)', colPrice, y + 5.5);
        doc.text('UM', colUnit, y + 5.5);
        y += 8;
      }

      const rowHeight = 7;
      if (idx % 2 === 0) {
        doc.setFillColor(248, 250, 252);
        doc.rect(margin, y, contentWidth, rowHeight, 'F');
      }

      doc.setTextColor(100, 116, 139);
      doc.setFontSize(7);
      doc.setFont(undefined, 'normal');
      doc.text(`${idx + 1}`, colNr + 2, y + 5);

      doc.setTextColor(15, 23, 42);
      doc.setFontSize(7.5);
      const nameMaxWidth = colBrand - colName - 4;
      let displayName = removeDiacritics(product.name || '');
      if (doc.getTextWidth(displayName) > nameMaxWidth) {
        while (doc.getTextWidth(displayName + '...') > nameMaxWidth && displayName.length > 0) {
          displayName = displayName.slice(0, -1);
        }
        displayName += '...';
      }
      doc.text(displayName, colName + 2, y + 5);

      doc.setTextColor(100, 116, 139);
      doc.setFontSize(7);
      doc.text(removeDiacritics(product.brand || '-'), colBrand, y + 5);

      doc.setTextColor(249, 115, 22);
      doc.setFont(undefined, 'bold');
      doc.setFontSize(8);
      doc.text(product.price != null ? product.price.toFixed(2) : '-', colPrice, y + 5);

      doc.setTextColor(100, 116, 139);
      doc.setFont(undefined, 'normal');
      doc.setFontSize(7);
      doc.text(removeDiacritics(product.unit || 'buc'), colUnit, y + 5);

      y += rowHeight;

      doc.setDrawColor(226, 232, 240);
      doc.setLineWidth(0.15);
      doc.line(margin, y, pageWidth - margin, y);
    });

    y += 6;
  });

  drawFooter(pageNum);
  return doc;
};
